import styled from 'styled-components';
import { Button } from 'antd';

export const DebugContainer = styled.div<{ 
  $x: number; 
  $y: number; 
  $isDragging: boolean;
}>`
  position: fixed;
  top: ${props => props.$y}px;
  left: ${props => props.$x}px;
  width: 320px;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 400px;
  overflow-y: auto;
  user-select: none;
  transition: ${props => props.$isDragging ? 'none' : 'box-shadow 0.2s ease'};
  cursor: ${props => props.$isDragging ? 'grabbing' : 'default'};

  &:hover {
    box-shadow: ${props => props.$isDragging ? 
      '0 8px 24px rgba(0, 0, 0, 0.25)' : 
      '0 6px 16px rgba(0, 0, 0, 0.2)'
    };
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const DebugHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const CloseButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding: 0;
  border: none;
  background: transparent;
  color: #8c8c8c;
  font-size: 12px;

  &:hover {
    background: #f5f5f5;
    color: #262626;
  }

  &:focus {
    background: #f5f5f5;
    color: #262626;
  }
`;

export const FeatureFlagItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;
